import axios from './axios';
import {
  API_SALVAGE_LIST,
  API_SALVAGE_PDF,
  API_URL_AUCTION,
  API_URL_BODY_TYPE_FILTERATION,
  API_URL_CAR_INFO_BY_VIN_NUMBER,
  API_URL_CAR_INFO_VIN,
  API_URL_CAR_LISTING,
  API_URL_Compare_GENERATE_PDF,
  API_URL_GENERATE_PDF,
  API_URL_MARKET_VALUE,
  API_URL_MARKET_VALUE_PRICE,
  API_URL_PREMIUM_VIN_DECODE,
  API_URL_PRICE_FILTERATION,
  API_URL_SALE_HISTORY,
  API_URL_SIGNIN,
  API_URL_SIGNUP,
  API_URL_YEAR_FILTERATION,
} from './urls';

// 1 Car Information by Vin Number API
export const getCarinfoByVin = async (vin) => {
  try {
    const res = await axios.get(`${API_URL_CAR_INFO_BY_VIN_NUMBER}/${vin}`);
    console.log('getCarinfoByVin:res', res);
    return { data: res?.data?.result };
  } catch (error) {
    console.log('getCarinfoByVin:error', error);
    return error;
  }
};

export const generatePDF = async (payload) => {
  try {
    const res = await axios.post(`${API_URL_GENERATE_PDF}`, payload,
      {
        responseType: 'blob', // Important to receive the response as a Blob
      }
    );
    return { data: res?.data };
  } catch (error) {
    return error;
  }
};

export const logIn = async (payload) => {
  try {
    const res = await axios.post(`${API_URL_SIGNIN}`, payload);
    return { data: res?.data };
  } catch (error) {
    return error;
  }
};
export const signUp = async (payload) => {
  try {
    const res = await axios.post(`${API_URL_SIGNUP}`, payload);
    return { data: res?.data };
  } catch (error) {
    return error;
  }
};

export const generateComparePDF = async (payload) => {
  try {
    const res = await axios.post(`${API_URL_Compare_GENERATE_PDF}`, payload,
      {
        responseType: 'blob', // Important to receive the response as a Blob
      }
    );
    return { data: res?.data };
  } catch (error) {
    return error;
  }
};

export const generateSalvagePDF = async (payload) => {
  try {
    const res = await axios.post(`${API_SALVAGE_PDF}`, payload,
      {
        responseType: 'blob', // Important to receive the response as a Blob
      }
    );
    return { data: res?.data };
  } catch (error) {
    return error;
  }
};

export const getCarPremiumDecode = async (vin) => {
  try {
    const res = await axios.get(`${API_URL_PREMIUM_VIN_DECODE}/${vin}`);
    console.log('getCarinfoByVin:res', res);
    return { data: res?.data?.result };
  } catch (error) {
    console.log('getCarinfoByVin:error', error);
    return error;
  }
};

export const carInfoVin = async (vin) => {
  try {
    const res = await axios.get(`${API_URL_CAR_INFO_VIN}/${vin}`);
    console.log('getCarinfoByVin:res', res);
    return { data: res?.data?.result };
  } catch (error) {
    console.log('getCarinfoByVin:error', error);
    return error;
  }
};
export const marketValue = async (vin) => {
  try {
    const res = await axios.get(`${API_URL_MARKET_VALUE_PRICE}?vin=${vin}`);
    return { data: res?.data?.result, vin: res.data.vin };
  } catch (error) {
    return error;
  }
};


// 2 Car Listing API
export const getCarListing = async ({
  make,
  price_min,
  price_max,
  year_min,
  year_max,
  model,
  city, trim,radius,mileage
}, currPage) => {
  try {
    const res = await axios.get(
      `${API_URL_CAR_LISTING}?&condition=used&year_min=${year_min}&year_max=${year_max}&mileage=${mileage}&price_min=${price_min}&price_max=${price_max}&make=${make}&model=${model}&postal_code=${city}&radius=${radius}&page=${currPage}&trim=${trim}`
    );
    console.log('getCarListing:res', res);
    return { data: res?.data?.result };
  } catch (error) {
    console.log('getCarListing:error', error);
    throw error;
  }
};

export const getSalvageCarListing = async ({
  condition,
  make,
  mileage,
  price_min,
  price_max,
  year_min,
  year_max,
  body_style,
  model,radius,
  city, trim,mileage_min,mileage_max
}, currPage) => {
  try {
    const res = await axios.get(
      `${API_SALVAGE_LIST}?year_min=${year_min}&year_max=${year_max}&price_min=${price_min}&price_max=${price_max}&manufacturer=${make}&model=${model}&trim=${trim}&radius=${radius}&postal_code=${city}&page=${currPage}`
    );
    console.log('getCarListing:res', res);
    return { data: res?.data?.data };
  } catch (error) {
    console.log('getCarListing:error', error);
    throw error;
  }
};

// 3 Sale History API
export const getSaleHistory = async (vin) => {
  try {
    const res = await axios.get(`${API_URL_SALE_HISTORY}/${vin}`);
    console.log('getCarinfoByVin:res', res);
    return res;
  } catch (error) {
    console.log('getCarinfoByVin:error', error);
    return error;
  }
};

// 4 Auction API
export const getAuction = async (vin) => {
  try {
    const res = await axios.get(`${API_URL_AUCTION}/${vin}`);
    console.log('getCarinfoByVin:res', res);
    return res;
  } catch (error) {
    console.log('getCarinfoByVin:error', error);
    return error;
  }
};

// 5. Market value on the basis of Year, car,model
export const getCarMarketValue = async ({
  year,
  make,
  model,
  state,
  mileage_value,
}) => {
  try {
    const res = await axios.get(
      `${API_URL_MARKET_VALUE}?year=${year}&make=${make}&model=${model}&state=${state}&mileage_value=${mileage_value}}`
    );
    console.log('getCarinfoByVin:res', res);
    return res;
  } catch (error) {
    console.log('getCarinfoByVin:error', error);
    return error;
  }
};

// 6. Car filtered by bodyStyle, price, year
export const getCarByBodyStylePriceYear = async (filter) => {
  const endpoint =
    filter.by === 'bodyStyle'
      ? API_URL_BODY_TYPE_FILTERATION
      : filter.by === 'price'
        ? API_URL_PRICE_FILTERATION
        : filter.by === 'year'
          ? API_URL_YEAR_FILTERATION
          : '';
  const param = filter.by === 'bodyStyle' ? filter.value + '/1' : '1';
  try {
    const res = await axios.get(`${endpoint}/${param}`);
    console.log('getCarByBodyStyle:res', res);
    return { data: res?.data?.result };
  } catch (error) {
    console.log('getCarByBodyStyle:error', error);
    return error;
  }
};
